export default __webpack_public_path__ + "static/media/goodGhosting.b7f901ff.jpg";